import React from "react";
import { Link } from "react-router-dom";
import { Zap, Truck, Cable, Snowflake, BatteryCharging, ArrowUpRight } from "lucide-react";
import { SITE } from "../../site.config";

const ICONS = { Zap, Truck, Cable, Snowflake, BatteryCharging };

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-black py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-cyan-pz" />
              <span className="bebas text-cyan-pz tracking-[0.3em] text-sm">
                WHAT WE DO
              </span>
            </div>
            <h2 className="bebas text-white text-5xl md:text-7xl leading-[0.9] max-w-3xl">
              SERIOUS POWER FOR <br />
              <span className="text-cyan-pz">SERIOUS RIGS.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md barlow text-base md:text-lg">
            Towing electrics first — Tow-Pro brake controllers, 12 pin plugs and Anderson plugs — plus
            under-bonnet dual battery, 4x4 electrical and auto air conditioning, all done properly at our Kunda Park workshop.
            Workshop rate{" "}
            <span className="text-cyan-pz bebas tracking-wider">
              {SITE.business.hourlyRate} ({SITE.business.hourlyRateNote})
            </span>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {SITE.services.map((s, i) => {
            const Icon = ICONS[s.icon] || Zap;
            return (
              <Link
                key={s.key}
                to={s.href}
                data-testid={`service-card-${s.key}`}
                className="group relative block bg-[#0A0A0A] border border-white/10 hover:border-cyan-pz transition-all duration-300 overflow-hidden clip-perf"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700 grayscale-[30%] group-hover:grayscale-0"
                  />
                </div>
                <div className="absolute top-5 left-5 bg-black/80 backdrop-blur-sm border border-cyan-pz/40 p-3">
                  <Icon className="w-6 h-6 text-cyan-pz" />
                </div>
                <div className="absolute top-5 right-5 bebas text-cyan-pz/60 text-sm tracking-widest">
                  0{i + 1}
                </div>

                <div className="p-6 md:p-8">
                  <p className="bebas text-cyan-pz tracking-[0.2em] text-sm mb-2">
                    {s.kicker}
                  </p>
                  <h3 className="bebas text-white text-3xl md:text-4xl leading-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-white/60 barlow leading-relaxed mb-5">
                    {s.desc}
                  </p>
                  <ul className="grid grid-cols-2 gap-x-4 gap-y-2 mb-6">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="text-white/70 text-sm barlow flex items-start gap-2"
                      >
                        <span className="text-cyan-pz mt-1">▸</span>
                        {b}
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center gap-2 bebas text-white tracking-widest text-base group-hover:text-cyan-pz transition-colors">
                    VIEW SERVICE & PRICING
                    <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
